import { Component, Input, OnInit } from '@angular/core';
import { Region } from 'src/app/model/Cuentas.model';

@Component({
  selector: 'app-plan-de-mejoramiento',
  templateUrl: './plan-de-mejoramiento.component.html',
  styleUrls: ['./plan-de-mejoramiento.component.css']
})
export class PlanDeMejoramientoComponent implements OnInit {

  @Input() region : Region;
  menuMostrar = "";
  showDetalle:boolean;
  simulacion:boolean=false;

  constructor() { }

  ngOnInit(): void {
    this.simulacion=false;
    this.showDetalle=false;
    this.menuMostrar='inicio';
  }

}
